<script setup lang="ts">
import { Button } from '@/components/ui/button';
import EmptyState from '@/components/ui/empty-state/EmptyState.vue';
import EntityRow from '@/components/workspace/EntityRow.vue';
import SectionSurface from '@/components/workspace/SectionSurface.vue';
import { ChevronRight, Mail, MessageSquare } from 'lucide-vue-next';
import type { ClientOverviewChannel, ClientOverviewConversationItem } from './types';

interface Props {
    items: ClientOverviewConversationItem[];
    summary: string;
    channelIcon: (channel: ClientOverviewChannel) => any;
    channelLabel: (channel: ClientOverviewChannel) => string;
}

defineProps<Props>();

const emit = defineEmits<{
    (e: 'open-comms'): void,
}>();
</script>

<template>
    <SectionSurface title="Latest conversation" description="A preview of the newest client communication." :icon="MessageSquare" density="compact" presentation="editorial" content-layout="flush">
        <template #actions><Button variant="ghost" size="icon" aria-label="Open comms" @click="emit('open-comms')"><ChevronRight class="size-4" /></Button></template>
        <EmptyState v-if="items.length === 0" embedded title="No conversation yet" :description="summary || 'Messages and touchpoints will appear here.'">
            <template #actions><Button variant="outline" size="sm" @click="emit('open-comms')"><Mail class="mr-2 size-4" />Open comms</Button></template>
        </EmptyState>
        <EntityRow v-else :title="items[0].title" :description="`${items[0].actorName || 'Client'} • ${items[0].relativeAt}`" :meta="channelLabel(items[0].channel)" :icon="channelIcon(items[0].channel)" interactive @activate="emit('open-comms')">
            <template #trailing><ChevronRight class="size-4" /></template>
        </EntityRow>
    </SectionSurface>
</template>
